var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nut-price",domProps:{"innerHTML":_vm._s(_vm.priceShow)}},[_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }